// import axiosInstance from "api/axiosInstance";
// import API from "api/endpoints";
// const ComplainceService = {
//   // Fetch all compliance records
//   fetchComplainces: async () => {
//     try {
//       const response = await axiosInstance.get(API.compliance.getAll);
//       return response.data || [];
//     } catch (error) {
//       console.error("Error fetching compliance data:", error);
//       throw error;
//     }
//   },

//   // Add a new compliance record
//   addComplaince: async (formData) => {
//     try {
//       await axiosInstance.post(API.compliance.create, formData);
//     } catch (error) {
//       console.error("Error adding compliance:", error);
//       throw error;
//     }
//   },
// };

// export default ComplainceService;

import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const ComplainceService = {
  // Fetch all compliance records
  fetchComplainces: async () => {
    try {
      const response = await axiosInstance.get(API.compliance.getAll);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching compliance data:", error);
      throw error;
    }
  },

  // Add a new compliance record
  addComplaince: async (formValues) => {
    try {
      const formData = new FormData();

      formData.append("PolicyName", formValues.PolicyName || "");
      formData.append("Description", formValues.Description || "");

      if (formValues.ExpiryDate) {
        const expiryDate = formValues.ExpiryDate.format("YYYY-MM-DD");
        formData.append("ExpiryDate", expiryDate);
      }

      if (formValues.PolicyDocumentFile && formValues.PolicyDocumentFile.length > 0) {
        formData.append("PolicyDocumentFile", formValues.PolicyDocumentFile[0].originFileObj);
      }

      for (let [key, value] of formData.entries()) {
      }

      const response = await axiosInstance.post(API.compliance.create, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error adding compliance:", error.response?.data || error);
      throw error;
    }
  },

  // Add new version of existing policy
  addPolicyVersion: async (versionData) => {
    try {
      const formData = new FormData();

      // Required fields
      formData.append("ComplianceId", versionData.ComplianceId);

      if (versionData.PolicyDocumentFile && versionData.PolicyDocumentFile.length > 0) {
        formData.append("PolicyDocumentFile", versionData.PolicyDocumentFile[0].originFileObj);
      }

      // Optional fields
      if (versionData.EffectiveDate) {
        formData.append("EffectiveDate", versionData.EffectiveDate.format("YYYY-MM-DD"));
      }

      if (versionData.ExpiryDate) {
        formData.append("ExpiryDate", versionData.ExpiryDate.format("YYYY-MM-DD"));
      }

      for (let [key, value] of formData.entries()) {
      }

      const response = await axiosInstance.post(API.compliance.addVersion, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error adding policy version:", error.response?.data || error);
      throw error;
    }
  },

  // Get policy details with versions
  getPolicyWithVersions: async (policyId) => {
    try {
      const response = await axiosInstance.get(API.compliance.getWithVersions(policyId));
      return response.data;
    } catch (error) {
      console.error("Error fetching policy details with versions:", error);
      throw error;
    }
  },

  downloadPolicy: (versionId) => {
    return axiosInstance.get(`/Compliance/download`, {
      params: {
        versionId: versionId,
      },
      responseType: "blob",
      timeout: 30000,
      headers: {
        Accept: "application/pdf, application/octet-stream",
      },
    });
  },
};

export default ComplainceService;
